module.exports = __webpack_public_path__ + "static/media/glomeworks.59dc232b.png";